import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import View from 'shared_features/athlete_popup';
import * as Actions from './actions';
import * as ProfileSelectors from 'shared_redux/selectors/view/profile';

const getViewModel = createSelector(
    ProfileSelectors.getIsCreating,
    ProfileSelectors.getIsUploadingAvatar,
    ProfileSelectors.getIsLoadingEmail,
    ProfileSelectors.getGroupId,
    ProfileSelectors.getFirstName,
    ProfileSelectors.getMiddleName,
    ProfileSelectors.getLastName,
    ProfileSelectors.getEmail,
    ProfileSelectors.getInviteStatus,
    ProfileSelectors.getTeamsWithDefaultGroups,
    ProfileSelectors.getDefaultOrgGroupId,
    ProfileSelectors.getSelectedTeamId,
    ProfileSelectors.getGroupsForSelectedTeam,
    (isShowing, isUploadingAvatar, isLoadingEmail, groupId, firstName, middleName, lastName, email, inviteStatus, teams, defaultOrgGroupId, selectedTeamId, groups) => {
        return {
            isShowing,
            isUploadingAvatar,
            isLoadingEmail,
            firstName,
            middleName,
            lastName,
            email,
            inviteStatus,
            groupId,
            selectedTeamId,
            teams,
            groups,
            defaultOrgGroupId,
            showAvatarOption: true,
            showRemove: false,
        }
    }
);

const mapStateToProps = (state) => getViewModel(state);

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateFirstName: Actions.updateFirstName,
        updateMiddleName: Actions.updateMiddleName,
        updateLastName: Actions.updateLastName,
        updateTeam: Actions.updateTeam,
        updateGroup: Actions.updateGroup,
        updateEmail: Actions.updateEmail,
        save: Actions.create,
        closeModal: Actions.closeModal,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default Container;
